import { AUCTIONS, CALLS } from 'constants/names'

export function getCallsFirestorePath(auctionId: string, callId = ''): string {
  return `/${AUCTIONS}/${auctionId}/${CALLS}/${callId}`
}
